import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';
import {
  BitrixWebhookRequest,
  BitrixWebhookRequestDetail,
  BitrixWebhookRequestFilter,
  BitrixWebhookStats,
  BitrixRequestStatus
} from '../interfaces/bitrix-webhook.interfaces';

@Injectable({
  providedIn: 'root'
})
export class BitrixWebhookService {
  private apiUrl = `${environment.apiUrl}/bitrix-requests`;

  constructor(private http: HttpClient) { }

  /**
   * Obtener todas las solicitudes con filtros opcionales
   */
  getRequests(filter?: BitrixWebhookRequestFilter): Observable<BitrixWebhookRequest[]> {
    let params = new HttpParams();

    if (filter) {
      if (filter.status !== undefined && filter.status !== null) {
        params = params.set('status', filter.status.toString());
      }
      if (filter.projectMnemonic) {
        params = params.set('projectMnemonic', filter.projectMnemonic);
      }
      if (filter.participantEmail) {
        params = params.set('participantEmail', filter.participantEmail);
      }
      if (filter.fromDate) {
        params = params.set('fromDate', new Date(filter.fromDate).toISOString());
      }
      if (filter.toDate) {
        params = params.set('toDate', new Date(filter.toDate).toISOString());
      }
      if (filter.failureStep) {
        params = params.set('failureStep', filter.failureStep);
      }
    }

    return this.http.get<BitrixWebhookRequest[]>(this.apiUrl, { params });
  }

  /**
   * Obtener detalle completo de una solicitud
   */
  getRequestById(id: number): Observable<BitrixWebhookRequestDetail> {
    return this.http.get<BitrixWebhookRequestDetail>(`${this.apiUrl}/${id}`);
  }

  /**
   * Reprocesar una solicitud fallida
   */
  retryProcessing(id: number): Observable<{ message: string }> {
    return this.http.post<{ message: string }>(`${this.apiUrl}/${id}/retry`, {});
  }

  /**
   * Obtener estadísticas de las solicitudes
   */
  getStats(): Observable<BitrixWebhookStats> {
    return this.http.get<BitrixWebhookStats>(`${this.apiUrl}/stats`);
  }

  /**
   * Obtener el nombre del estado en español
   */
  getStatusName(status: BitrixRequestStatus): string {
    switch (status) {
      case BitrixRequestStatus.Pending: return 'Pendiente';
      case BitrixRequestStatus.Processing: return 'Procesando';
      case BitrixRequestStatus.Success: return 'Exitoso';
      case BitrixRequestStatus.Failed: return 'Fallido';
      default: return 'Desconocido';
    }
  }

  /**
   * Obtener la clase de badge según el estado
   */
  getStatusBadgeClass(status: BitrixRequestStatus): string {
    switch (status) {
      case BitrixRequestStatus.Pending: return 'badge bg-warning text-dark';
      case BitrixRequestStatus.Processing: return 'badge bg-info text-white';
      case BitrixRequestStatus.Success: return 'badge bg-success';
      case BitrixRequestStatus.Failed: return 'badge bg-danger';
      default: return 'badge bg-secondary';
    }
  }

  /**
   * Obtener el icono según el estado
   */
  getStatusIcon(status: BitrixRequestStatus): string {
    switch (status) {
      case BitrixRequestStatus.Pending: return 'bi-clock-history';
      case BitrixRequestStatus.Processing: return 'bi-arrow-repeat';
      case BitrixRequestStatus.Success: return 'bi-check-circle-fill';
      case BitrixRequestStatus.Failed: return 'bi-x-circle-fill';
      default: return 'bi-question-circle';
    }
  }
}

